export const getReviewMethods = (t) => [
    { value: 'ecografia', label: t('admin.event.methodEcografia') },
    { value: 'palpacion', label: t('admin.event.methodPalpacion') },
    { value: 'analitica', label: t('admin.event.methodAnalitica') }
]